(function(window) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.questionGrader = (function() {
      return {
         FATHOM: 'FATHOM',
         XMP: 'XMP'
      };
   }());
}(this));
